import {
    Model
} from '@/lib/BaseModel';
import fieldSpec from '@/models/commonFieldsSchema';


var UploadSchema = {

    imageFilename: {
        label: 'Dog Image',
        truncate: 100,
        validation: {
            required: 'Must select an image file.'
        }
    },

    dogName: {
        label: fieldSpec.dogName.label,
        truncate: fieldSpec.dogName.maxLength,
        validation: {
            required: 'Must be filled in.'
        },
    },

    // Internal breed code, e.g. bordercollie
    // NOTE: See note below on 'breedDesc' re: when breedId is 'mixed'
    breedId: {
        label: 'Breed',
        truncate: 50,
        validation: {
            required: 'Must select your dog\'s breed.'
        },
    },

    // Human-readable breed, e.g. 'Border Collie'
    // breed is keyed to breedId, i.e. mapping: breedId => breed ... e.g. bordercollie => 'Border Collie'
    // breed: {
    //     label: 'Breed',
    //     truncate: 75
    // },

    // Breed description
    // This is a MANDATORY field on the client front-end when breedId = 'mixed', i.e. user 
    // must enter short description to describe the breed, e.g. 'collie/shepherd cross'
    breedDesc: {
        label: fieldSpec.breedDesc.label,
        truncate: fieldSpec.breedDesc.maxLength,
        validation: {
            breedDescRequired: 'Must be filled in.'
        }
    },


    // ************************ Make sure truncate values match maxLength attr in form field html ... and that 
    // 'size' in Firebase security rules is consistent too.

    fName: {
        label: fieldSpec.fName.label,
        truncate: fieldSpec.fName.maxLength,
        validation: {
            required: 'Must be filled in.'
        },
    },

    lName: {
        label: fieldSpec.lName.label,
        truncate: fieldSpec.lName.maxLength,
        validation: {
            required: 'Must be filled in.'
        },
    },

    city: {
        label: fieldSpec.city.label,
        truncate: fieldSpec.city.maxLength,
        validation: {
            required: 'Must be filled in.'
        },
    },

    state: {
        label: 'State',
        truncate: 2,
        validation: {
            stateRequired: 'Must select your state.'
        },
    },

    province: {
        label: fieldSpec.province.label,
        truncate: fieldSpec.province.maxLength,
        validation: {
            provinceRequired: 'Must be filled in.'
        }
    },

    // 2-character country abbreviation
    country: {
        label: 'Country',
        truncate: 2,
        validation: {
            required: 'Must select your country.',
            cannotBe: {
                '-': 'A country must be selected.'
            }
        },
    },

    // caption: {
    //     label: 'Caption'
    // },

    captionLastName: {
        label: 'Caption Last Name Option'
    },

    note: {
        label: 'Note',
        truncate: 300
    },

    specProjCode: {
        label: fieldSpec.specProjCode.label,
        truncate: fieldSpec.specProjCode.maxLength,
        validation: {
            validProjCode: 'Must be a valid code.'
        }
    }

}

var customValidationRules = {
    stateRequired: function (dataObj, propName, ruleObj, validator) {
        var val = dataObj[propName];
        val = validator.helpers.trim(val);
        if (val === '' || val === undefined || val === null) {
            var country = dataObj.country;
            if (country.match(/^[A-Z][A-Z]$/) && country === 'US') {
                var errMsg = ruleObj.stateRequired;
                validator.addError(propName, validator.getPropLabel(propName), errMsg);
            }
        }
    },
    provinceRequired: function (dataObj, propName, ruleObj, validator) {
        var val = dataObj[propName];
        val = validator.helpers.trim(val);
        if (val === '' || val === undefined || val === null) {
            var country = dataObj.country;
            if (country.match(/^[A-Z][A-Z]$/) && country !== 'US') {
                var errMsg = ruleObj.provinceRequired;
                validator.addError(propName, validator.getPropLabel(propName), errMsg);
            }
        }
    },
    breedDescRequired: function (dataObj, propName, ruleObj, validator) {
        var val = dataObj[propName];
        val = validator.helpers.trim(val);
        if (val === '' || val === undefined || val === null) {
            var breedId = dataObj.breedId;
            if (breedId === 'mixed') {
                var errMsg = ruleObj.breedDescRequired;
                validator.addError(propName, validator.getPropLabel(propName), errMsg);
            }
        }
    },
    validProjCode: function (dataObj, propName, ruleObj, validator) {
        var val = dataObj[propName];
        val = validator.helpers.trim(val);
        // If val is empty/undefined/null, do nothing, i.e. a blank value is ok.
        // Otherwise, check that it's of the proper format 
        if (val !== '' && val !== undefined && val !== null) {
            if (!/^sc-[a-z0-9]{5,20}$/i.test(val)) {
                var errMsg = ruleObj.validProjCode;
                validator.addError(propName, validator.getPropLabel(propName), errMsg);
            }
        }
    },
}

var Upload = Model.make('Upload', UploadSchema, {}, {}, customValidationRules);

export {
    Upload
};